import { render, staticRenderFns } from "./ModalAgregarVotacion.vue?vue&type=template&id=1f8a0036&scoped=true"
import script from "./ModalAgregarVotacion.vue?vue&type=script&lang=js"
export * from "./ModalAgregarVotacion.vue?vue&type=script&lang=js"
import style0 from "./ModalAgregarVotacion.vue?vue&type=style&index=0&id=1f8a0036&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8a0036",
  null
  
)

export default component.exports